import styled, { css } from 'styled-components';

// CONSTANTS
import { theme } from '../../constants/theme';

// ENUMS
import { CarouselVariant } from '../../enums/carousel.enum';

export const CarouselButton = styled.button`
  display: flex;
  outline: none;
  box-shadow: none;
  justify-content: center;
  align-items: center;
  width: 41px;
  height: 40px;
  border-radius: 8px;
  background: ${theme.colors.primary.white};
  border: 1px solid ${theme.colors.secondary.gray400};
  cursor: pointer;
`;

export const CarouselButtonsContainer = styled.div<{ variant: CarouselVariant }>`
  display: flex;

  ${({ variant }) =>
    variant === 'group' &&
    css`
      justify-content: center;
      padding-top: 20px;

      button:nth-child(1) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }

      button:nth-child(2) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    `}

  ${({ variant }) =>
    variant === 'separated' &&
    css`
      button:nth-child(2) {
        margin-left: 35px;
      }
    `}
`;
